<template>
    <div class="detail" :class="{loaded}">
        <div class="header article-item">
            <h2>{{article.title}}</h2>
            <div class="date">{{article.date}}</div>
            <!-- <div class="image" :style="{backgroundImage: `url(${images[article.id]})`}"></div> -->
            <img :src="images[article.id]" alt="">
        </div>
        <div class="container">
            <div class="wrapper" v-html="article.content"></div>
        </div>
        <!-- <div class="comment">
            <div class="wrapper">
                <h2>评论</h2>
                <ul>
                    <li v-for="(comment, index) in article.comment" :key="index">
                        <p>{{comment.name || '匿名'}} <span class="time">{{comment.time}}</span> </p>
                        <div class="content">{{comment.content}}</div>
                    </li>
                </ul>
            </div>
        </div> -->
    </div>
</template>
<script>
import datas from '../data/article.json';
export default {
    name: 'detail',
    props: {
        id: {}
    },
    data() {
        return {
            datas,
            article: {},
            loaded: false,
            scrollY: 0,
            images: {
                1: require('../../public/upload/01.jpg'),
                2: require('../../public/upload/02.jpg'),
                3: require('../../public/upload/03.jpg'),
                4: require('../../public/upload/04.jpg')
            }
        }
    },
    created() {
        document.body.scrollTo(0, 0);
        this.findData();
    },
    mounted() {
        setTimeout(() => {
            this.loaded = true;
        }, 5);
    },
    methods: {
        findData() {
            this.article = this.datas.filter(item => item.id == this.id)[0];
        }
    }
}
</script>
<style lang="less">
.detail{
    margin-top: calc(var(--header-height) / -1);
    .header{
        height: 50vh;
        transition: border-radius 0.5s;
        border-radius: 0;
        position: relative;
        user-select: none;
        overflow: hidden;
        &:after{
            content: '';
            position: absolute;
            width: 100%;
            height: 50px;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(0deg, var(--background-color), transparent);
            z-index: 5;
        }
        h2{
            top: 150px;
            font-size: 52px;
            left: 50%;
            padding-left: 0;
            white-space: nowrap;
            z-index: 2;
            transform-origin: 50% 310px;
            transform: translate3d(-49%, 0, -1px) scale(2);
        }
        .date{
            z-index: 2;
        }
        &:hover{
            box-shadow: none;
        }
        img{
            transform-origin: 50% 100%;
            transform: translateZ(-2px) scale(3);
        }
    }
    .container{
        opacity: 0;
        transform: translate(0, 50px);
        transition: 0.5s;
        will-change: opacity, transform;
        background-color: var(--background-color);
        .wrapper{
            // background-color: var(--box-color);
            padding: 20px;
            font-size: 18px;
            line-height: 2;
        }
        p{
            padding: 5px 0;
        }
    }
    &.loaded{
        .container{
            opacity: 1;
            transform: translate(0, 0);
        }
    }
    .comment{
        padding-top: 30px;
        h2{
            border-bottom: 1px solid var(--border-color);
            padding-bottom: 20px;
            margin-bottom: 20px;
        }
        li{
            padding: 10px 0 20px;
        }
        .time{
            opacity: 0.5;
            font-size: 14px;
        }
        .content{
            padding-top: 10px;
        }
    }
}
</style>